import { createApp } from "vue"
import AuthenticationSelect from "./authenticationSelect.vue"

// 全局维护认证弹窗实例列表
const authDialogInstances = new Set()

export default function ShowAuthenticationSelect(options) {
  // 创建一个节点，并将组件挂载上去
  const mountNode = document.createElement("div")
  document.body.appendChild(mountNode)
  
  const app = createApp(AuthenticationSelect, {
    ...options,
    visible: true,
    remove() {
      // 从实例列表中移除
      authDialogInstances.delete(appInstance)
      app.unmount(mountNode) //创建完后要进行销毁
      document.body.removeChild(mountNode)
    },
  })
  
  const appInstance = app.mount(mountNode)
  
  // 将实例添加到全局列表
  authDialogInstances.add(appInstance)
  
  return appInstance
}

// 导出关闭所有认证弹窗的函数
export function closeAllAuthenticationDialogs() {
  authDialogInstances.forEach(instance => {
    try {
      // 调用实例的关闭方法
      if (instance && typeof instance.close === 'function') {
        instance.close()
      } else if (instance && typeof instance.onCloseClick === 'function') {
        instance.onCloseClick()
      }
    } catch (error) {
      console.warn('关闭认证弹窗时出错:', error)
    }
  })
  // 清空实例列表
  authDialogInstances.clear()
}